(() => {
  const MARKER="SIP_PUBLIC_TICKETING_DETAIL_V8";
  const HIDE="sip-ticket-v8-hide";
  const STYLE_ID="sip-ticket-v8-style";
  let queued=false;

  function ticket(){
    return (String(window.location.pathname||"/").replace(/\/+$/,"")||"/")==="/it/ticketing-problem";
  }

  function visible(el){
    if(!(el instanceof HTMLElement)) return false;
    const cs=getComputedStyle(el);
    if(cs.display==="none"||cs.visibility==="hidden"||Number(cs.opacity||1)===0) return false;
    const r=el.getBoundingClientRect();
    return r.width>20&&r.height>20;
  }

  function text(el){
    return String(el?.textContent||"").replace(/\s+/g," ").trim().toUpperCase();
  }

  function historyOpen(){
    let create=false, progress=false;
    for(const el of [...document.querySelectorAll("body *")]){
      if(!visible(el)) continue;
      const t=text(el);
      if(!t||t.length>240) continue;
      if(t.includes("CREATE_TICKET")) create=true;
      if(t.includes("UPDATE_PROGRESS")||t.includes("VERIFY_TICKET")||t.includes("AUTO_ESCALATE_SLA")||t.includes("ADD_COMMENT")) progress=true;
      if(create&&progress) return true;
    }
    return false;
  }

  function label(el){
    if(!(el instanceof HTMLElement)||!visible(el)) return false;
    const t=text(el);
    return t.length<=100 && /TOTAL\s*\d+\s*TICKET/.test(t);
  }

  function container(labelEl){
    let el=labelEl;
    for(let d=0;el&&d<8;d++,el=el.parentElement){
      if(!(el instanceof HTMLElement)) continue;
      const r=el.getBoundingClientRect();
      const cls=String(el.className||"").toLowerCase();
      const graphic=!!el.querySelector("canvas,svg")||/chart|donut|pie|summary|stat/.test(cls);
      const size=r.width>=70&&r.height>=70&&r.width<=900&&r.height<=900;
      if(size&&(graphic||d>=1)) return el;
    }
    return labelEl;
  }

  function style(){
    if(document.getElementById(STYLE_ID)) return;
    const s=document.createElement("style");
    s.id=STYLE_ID;
    s.textContent=`.${HIDE}{display:none!important;visibility:hidden!important;pointer-events:none!important}`;
    document.head.appendChild(s);
  }

  function restore(){
    document.querySelectorAll('[data-sip-ticket-v8="1"]').forEach(el=>{
      el.classList.remove(HIDE);
      delete el.dataset.sipTicketV8;
    });
  }

  function apply(){
    if(!ticket()){restore();return}
    style();

    if(!historyOpen()){restore();return}

    const targets=new Set([...document.querySelectorAll("body *")].filter(label).map(container));
    targets.forEach(el=>{
      if(el instanceof HTMLElement){
        el.classList.add(HIDE);
        el.dataset.sipTicketV8="1";
      }
    });

    if(targets.size) console.log(`[${MARKER}] hidden=${targets.size}`);
  }

  function queue(){
    if(queued)return;
    queued=true;
    setTimeout(()=>{queued=false;apply()},70);
  }

  new MutationObserver(queue).observe(document.documentElement,{
    childList:true,subtree:true,attributes:true,attributeFilter:["class","style"]
  });
  window.addEventListener("popstate",queue);
  [100,300,800,1600].forEach(ms=>setTimeout(queue,ms));
  console.log(`[${MARKER}] installed`);
})();
